import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from 'react-query';
import Login from './Pages/Account/signin';
import MainLayout from './Layouts/MainLayout';
import Recover from './Pages/Account/recoverpassword';
import Menu from './Pages/Menu';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import MeuPerfil from './Pages/User/meu-perfil';
import EditPerfil from './Pages/User/editar-meu-perfil';
import Distribuir from './Pages/Distribuicao/distribuir';
import Aprovar from './Pages/Distribuicao/aprovar';
import Autorizar from './Pages/Distribuicao/autorizar';
import Historico from './Pages/Historico/historico';
import Transferir from './Pages/Distribuicao/tranferir';
import PreAuthPlan from './Pages/Planificacao/pre-auth';
import AuthPlan from './Pages/Planificacao/auth';
import Auth from './Pages/Account/auth';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/account/login',
    element: <Login />
  },
  {
    path: '/auth/:token',
    element: <Auth />
  },
  {
    path: '/account/resetpass',
    element: <Recover />
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <Menu />
      },
      {
        path: '/nova-distribuicao',
        element: <Distribuir />
      },
      {
        path: '/aprovar-distribuicao',
        element: <Aprovar />
      },
      {
        path: '/autorizar-distribuicao',
        element: <Autorizar />
      },
      {
        path: '/transferir-distribuicao',
        element: <Transferir />
      },
      {
        path: '/aprovar-planificacao',
        element: <PreAuthPlan />
      },
      {
        path: '/autorizar-planificacao',
        element: <AuthPlan />
      },
      {
        path: '/historico',
        element: <Historico />
      },
      {
        path: '/meu-perfil',
        element: <MeuPerfil/>
      },
      {
        path: '/editar-perfil',
        element: <EditPerfil/>
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router}/>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
